import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoWhite from "../assets/images/logo/logo.png";

//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import { useSelector } from "react-redux";

const Sidebar = ({ layoutType }) => {
  const globalTheme = useSelector(state => state.Theme);
  const logo = globalTheme?.logo || logoWhite;


  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body?.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };
  return (
    <React.Fragment>
      <div
        style={{ background: "var(--vz-secondary)" }}
        className="app-menu navbar-menu">
        <div

          className="navbar-brand-box mt-2">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img style={{ height: 'auto' }} src={logo} alt="" width="80%" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" width="80%" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img style={{ height: 'auto' }} src={logo} alt="" width="80%" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" width="80%" />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === "twocolumn" ? (
          <React.Fragment>
            <TwoColumnLayout />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar
              id="scrollbar" className="h-100">
              <Container
                fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>

            {!globalTheme?.uiCustomization?.hidePoweredBy && (
              <div
                style={{
                  position: "absolute",
                  bottom: "1rem",
                  left: 0,
                  width: "100%",
                  textAlign: "center",
                  zIndex: 1
                }}
              >
                <small className="text-light d-block mb-1">Powered by</small>
                <a
                  href="https://baxrx.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-inline-block"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={logoWhite}
                    alt="Powered by BaxRx"
                    style={{ maxWidth: "80px", height: "auto" }}
                  />
                </a>
              </div>
            )}

            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
